export const PILOT_ENABLED_PIPELINES = Object.freeze([
  'size',
  'encapsulation',
]);

const PILOT_ENABLED_PIPELINE_IDS = new Set(PILOT_ENABLED_PIPELINES);

export function isPilotPipelineEnabled(pipelineId) {
  return PILOT_ENABLED_PIPELINE_IDS.has(String(pipelineId || '').toLowerCase());
}

export const WORKFLOW_PIPELINES = [
  {
    id: 'encapsulation',
    title: 'Encapsulation',
    description: 'Compute EE from total + free RNA files.',
    icon: 'encapsulation',
    action: { type: 'modal', pipeline: 'encapsulation' },
    history: {
      provider: 'workflowRuns',
      options: { pipeline: 'encapsulation' },
    },
  },
  {
    id: 'size',
    title: 'Size Calculation',
    description: 'Analyze size distribution from a single CSV.',
    icon: 'size',
    action: { type: 'modal', pipeline: 'size' },
    history: {
      provider: 'workflowRuns',
      options: { pipeline: 'size' },
    },
  },
  {
    id: 'mapping',
    title: 'LC-MS Mapping',
    description: 'Generate RNase digest coverage and QC plots from mzML files.',
    icon: 'mapping',
    action: { type: 'route', to: '/mapping' },
    history: {
      provider: 'moduleLog',
      options: { storageKey: 'workflowHistory:mapping', maxEntries: 10 },
    },
  },
  {
    id: 'stability',
    title: 'Stability Planner',
    description: 'Plan, manage, and review stability studies.',
    icon: 'stability',
    action: { type: 'route', to: '/stability' },
    history: {
      provider: 'moduleLog',
      options: { storageKey: 'workflowHistory:stability' },
    },
  },
  {
    id: 'pressure',
    title: 'Pressure Analysis',
    description: 'Calculate pressure differentials for capillary systems.',
    icon: 'pressure',
    action: { type: 'route', to: '/pressure' },
    history: {
      provider: 'moduleLog',
      options: { storageKey: 'workflowHistory:pressure' },
    },
  },
  {
    id: 'ribo-green',
    title: 'RiboGreen',
    description: 'Upload plates and calculate fluorescence regressions.',
    icon: 'riboGreen',
    action: { type: 'route', to: '/ribo-green' },
    history: {
      provider: 'moduleLog',
      options: { storageKey: 'workflowHistory:ribo-green' },
    },
  },
];

export const WORKFLOW_BY_ID = WORKFLOW_PIPELINES.reduce((acc, item) => {
  acc[item.id] = item;
  return acc;
}, {});

export const PILOT_WORKFLOW_PIPELINES = WORKFLOW_PIPELINES.filter(({ id }) =>
  isPilotPipelineEnabled(id)
);

const PILOT_ANALYSIS_LABELS = {
  size: 'Size',
  encapsulation: 'Encapsulation',
};

export const PILOT_ANALYSIS_OPTIONS = PILOT_ENABLED_PIPELINES.map((value) => ({
  value,
  label: PILOT_ANALYSIS_LABELS[value],
}));
